import { BaseMenuHelpPanel } from "./BaseMenuHelpPanel";
import { Env } from "../../settings/Env";
import { text } from "../../TextResources";
import { Image3D } from "@dreamcam/babylon-tools";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
export class VideoClipHelpPanel extends BaseMenuHelpPanel {
    _createContent() {
        this._root.addControl(this._createControllerImage());
        this._addLabels();
        this._root.addControl(this._createDragImage());
        const hp = Env.videoClip.menu.helpPanel;
        const dragSection = this._addDragSection();
        dragSection.leftInPixels = this._mesh2d.m2px(hp.dragSection.left);
        dragSection.topInPixels = this._mesh2d.m2px(hp.dragSection.top);
        this._root.addControl(this._createCloseImage());
        const closeSection = this._addCloseSection();
        closeSection.leftInPixels = this._mesh2d.m2px(hp.closeSection.left);
        closeSection.topInPixels = this._mesh2d.m2px(hp.closeSection.top);
    }
    _createControllerImage() {
        const im = Env.videoClip.menu.helpPanel.controllerImage;
        const result = new Image3D(`${this._getControlNamePrefix()}ControllerImage`, im.img);
        result.heightInPixels = this._mesh2d.m2px(im.height);
        result.widthInPixels = this._mesh2d.m2px(im.width);
        result.leftInPixels = this._mesh2d.m2px(im.left);
        result.topInPixels = this._mesh2d.m2px(im.top);
        result.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        result.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        return result;
    }
    _createDragImage() {
        const im = Env.videoClip.menu.helpPanel.dragImage;
        const result = new Image3D(`${this._getControlNamePrefix()}DragImage`, im.img);
        result.widthInPixels = this._mesh2d.m2px(im.width);
        result.heightInPixels = this._mesh2d.m2px(im.height);
        result.leftInPixels = this._mesh2d.m2px(im.left);
        result.topInPixels = this._mesh2d.m2px(im.top);
        result.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        result.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        return result;
    }
    _createCloseImage() {
        const im = Env.videoClip.menu.helpPanel.closeMenuImage;
        const result = new Image3D(`${this._getControlNamePrefix()}CloseMenuImage`, im.img);
        result.heightInPixels = this._mesh2d.m2px(im.height);
        result.widthInPixels = this._mesh2d.m2px(im.width);
        result.leftInPixels = this._mesh2d.m2px(im.left);
        result.topInPixels = this._mesh2d.m2px(im.top);
        result.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        result.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        return result;
    }
    _getControlNamePrefix() {
        return "videoClipMenuHelpPanel";
    }
    _addLabels() {
        const i = Env.broadcast.menu.helpPanel.controller.icons;
        const l = Env.videoClip.menu.helpPanel.labels;
        this._addLabel("Select", text.broadcast_menu_helpPanel_controller_select, l.text.positions.select);
        this._addLabel("Lobby", text.broadcast_menu_helpPanel_controller_lobby, l.text.positions.lobby);
        this._addLabel("PlayPause", text.videoClip_menu_helpPanel_controller_play_pause, l.text.positions.playPause);
        this._addLabel("Drag", text.broadcast_menu_helpPanel_controller_drag, l.text.positions.drag);
        this._addLabel("ForwardRewind", text.videoClip_menu_helpPanel_controller_forward_rewind, l.text.positions.forwardRewind);
        this._addLabel("Zoom", text.broadcast_menu_helpPanel_controller_zoom, l.text.positions.zoom);
        this._addLabel("Reset", text.broadcast_menu_helpPanel_controller_reset, l.text.positions.reset);
        this._addLabel("Recenter", text.broadcast_menu_helpPanel_controller_recenter, l.text.positions.recenter);
        this._addIcon("ForwardRewind", i.leftRight, l.icons.positions.forwardRewind);
        this._addIcon("Zoom", i.upDown, l.icons.positions.zoom);
        this._addIcon("Reset", i.press, l.icons.positions.reset);
        this._addIcon("Recenter", i.longPress, l.icons.positions.recenter);
        this._addSubLabel("Lobby", l.longPressText.positions.lobby);
        this._addSubLabel("Recenter", l.longPressText.positions.recenter);
    }
}
